var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public"},[_c('v-layout',[_c('v-card',{ref:"card",staticStyle:{"max-width":"400px","margin":"auto","width":"100%"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }